export default __webpack_public_path__ + "static/media/loading-gif.035c874b.gif";